var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticStyle:{"width":"100%","height":"100vh","border":"none"},attrs:{"src":"/website.html"}})}
var staticRenderFns = []

export { render, staticRenderFns }